module.exports = __webpack_public_path__ + "img/no_article.965ea66e.png";